import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=495fb6ae&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "./Header.vue?vue&type=style&index=0&id=495fb6ae&lang=less&scoped=true&"
import style1 from "./Header.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fb6ae",
  null
  
)

export default component.exports